export const getPasswordValidationRule = (rule) => {
    return data => {
        const regex = new RegExp(rule.regExpression);
        const isValid = typeof data === 'string' && regex.test(data);
        if (!isValid)
            return rule.displayText;
    };
};
//# sourceMappingURL=password-validation-rule.js.map